const allowedTags = new Set([
  "svg",
  "g",
  "path",
  "circle",
  "ellipse",
  "line",
  "polyline",
  "polygon",
  "rect",
  "title",
  "desc"
]);

const allowedAttributes = new Set([
  "aria-hidden",
  "class",
  "cx",
  "cy",
  "d",
  "fill",
  "fill-rule",
  "height",
  "id",
  "points",
  "r",
  "rx",
  "ry",
  "stroke",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-width",
  "transform",
  "viewbox",
  "viewBox",
  "width",
  "x",
  "x1",
  "x2",
  "xmlns",
  "y",
  "y1",
  "y2"
]);

function sanitizeElement(element: Element): boolean {
  const tagName = element.tagName.toLowerCase();
  if (!allowedTags.has(tagName)) {
    return false;
  }

  Array.from(element.attributes).forEach(attribute => {
    const attributeName = attribute.name;
    const normalizedName = attributeName.toLowerCase();
    const normalizedValue = attribute.value.trim().toLowerCase();

    if (
      normalizedName.startsWith("on") ||
      !allowedAttributes.has(attributeName) ||
      normalizedValue.includes("javascript:") ||
      normalizedValue.includes("data:")
    ) {
      element.removeAttribute(attributeName);
    }
  });

  Array.from(element.childNodes).forEach(child => {
    if (child.nodeType === Node.ELEMENT_NODE && !sanitizeElement(child as Element)) {
      element.removeChild(child);
    }
  });

  return true;
}

export function sanitizeSvg(svg: string | null | undefined): string {
  if (svg === null || svg === undefined || svg.trim().length === 0) {
    return "";
  }

  const document = new DOMParser().parseFromString(svg, "image/svg+xml");
  if (document.getElementsByTagName("parsererror").length > 0) {
    return "";
  }

  const root = document.documentElement;
  if (root.tagName.toLowerCase() !== "svg" || !sanitizeElement(root)) {
    return "";
  }

  return new XMLSerializer().serializeToString(root);
}